<div class="modal-header">
  <h2 class="modal-title">Something went wrong</h2>
  <button type="button" class="close" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true"></span>
  </button>
</div>
<div class="modal-body">
  <div class="alert alert-danger" role="alert">
    Unexpected error occurred.
    <p>Please close this window and try again.</p>
    <p>If this error persists, please contact support:</p>
    <p>
      <i aria-hidden="true" class="pbi-icon-mini pbi-monitor" style="color: black"> </i>
      <span style="padding-left: 10px"
        ><a target="_blank" href="https://support.precisely.com/contact/"
          >Tech Support & Client Services Contacts</a
        ></span
      >
    </p>
  </div>
  <h3>Support Information</h3>
  <div class="card" style="background-color: #f0f0f0">
    <div class="card-body">
      <div class="contentFix">
        {{ error.stack }}
      </div>
    </div>
  </div>
</div>
<div class="modal-footer"></div>
